import BgDocument from "../assets/curriculum.png";

const CurriculumPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 font-sans text-gray-800 flex flex-col items-center">
      <img src={BgDocument} alt="Logo" width="100%" />
    </div>
  );
};

export default CurriculumPage;
